import { Tooltip } from "@mui/material";
import Fade from "@mui/material/Fade";
import React from "react";

export default function FormulaTooltips({ title, windowWidth, content }) {
  return (
    <Tooltip
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 600 }}
      componentsProps={{
        tooltip: {
          sx: {
            background: "#1d0d31",
            border: "1px solid #1e1532",
            color: "white",
            fontSize: "13px",
            fontWeight: 500,
            padding: "5px 15px",
            textAlign: "left",
            marginBottom: "30px",

            maxWidth: "450px", // Set the maximum width for the tooltip
          },
        },
        arrow: {
          sx: {
            fontSize: 16,
            color: "#1d0d31",
          },
        },
      }}
      title={content}
      placement="top"
      arrow
    >
      <h5
        style={{
          fontSize: windowWidth <= 1500 ? "16px" : "18px",
          margin: 0,
        }}
      >
        {title}
      </h5>
    </Tooltip>
  );
}
